import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, MenuItem, Select, Stack, TextField, Tooltip } from "@mui/material";
import moment from "moment";
import { useEffect, useImperativeHandle } from "react";
import { forwardRef } from "react";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import CustomDatePicker from "../utilities/CustomDatePicker";
import { checkNumber } from "../utilities/FormValidation";

const DailyExchangeRateForm = forwardRef((props, ref) => {
    const [date, setDate] = useState(null);
    const [exchangeRate, setExchangeRate] = useState();
    const [editData, setEditData] = useState();
    const [error, setError] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [createdAt, setCreatedAt] = useState();
    const [createdBy, setCreatedBy] = useState();
    const [updatedAt, setUpdatedAt] = useState();
    const [validError, setValidError] = useState();
    const [updatedBy, setUpdatedBy] = useState();
    const [decimalPlace, setDecimalPlace] = useState(4);
    const [checkStatus, setCheckStatus] = useState(false);
    const [existOpen, setExistOpen] = useState(false);
    const [existId, setExistId] = useState();
    const [snackState, setSnackState] = useState(false);
    const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.dailyExchangeRate}`;
    const params = props;

    const handleSubmit = async () => {
        const calculated = (1 / exchangeRate).toFixed(decimalPlace);
        let rateData = {
            date: date,
            resourceMoneyUnit: 'EUR',
            euroRate: Number(exchangeRate).toFixed(decimalPlace),
            targetMoneyUnit: 'AED',
            value: 1,
            calculated: calculated
        }

        if (existId || props.id) {
            try {
                if (editData.date === date) {
                    if (parseFloat(Number(exchangeRate)) === 0 || isNaN(parseFloat(Number(exchangeRate)))) {
                        setError(`The value for Exchange rate cannot be 0`)
                    } else {
                        const updateData = await OAuthService.updateData(url, existId || props.id, rateData)
                        if (updateData.data) {
                            setSuccessMsg("Data Updated successfully");
                            setSnackState(true);
                            return "Data Updated successfully";
                        }
                    }
                } else {
                    try {
                        const checkDuplicateData = await OAuthService.getList(url + '/search/findByDate?date=' + date)
                        if (checkDuplicateData.data.id !== params.id) {
                            setError(`Daily Exchange Rate with ${date} already exist into system!`);
                            setExistOpen(true)
                        }

                    } catch (error) {
                        if (error?.response?.status === 404) {
                            if (new Date() < new Date(date)) {
                                setError(`Select exchange date less than system date!`)
                            } else {
                                if (parseFloat(Number(exchangeRate)) === 0 || isNaN(parseFloat(Number(exchangeRate)))) {
                                    setError(`The value for Exchange rate cannot be 0`)
                                } else {

                                    const updateData = await OAuthService.updateData(url, existId || props.id, rateData)
                                    if (updateData.data) {
                                        setSuccessMsg("Data Updated successfully");
                                        setSnackState(true);
                                        return "Data Updated successfully";

                                    }
                                }
                            }

                        }
                    }
                }
            } catch (error) {

            }
        } else {
            try {
                const checkDuplicateData = await OAuthService.getList(url + '/search/findByDate?date=' + date)
                if (checkDuplicateData.data) {
                    setError(`Daily Exchange Rate with ${date} already exist into system!`);
                    setExistOpen(true)
                } else {
                    const addData = await OAuthService.addData(`${process.env.REACT_APP_FINANCE_API_KEY_URL}api/${oAuthServiceConfig.dailyExchange}/save`, rateData)
                    if (addData) {
                        setSuccessMsg("Data saved successfully")
                        setSnackState(true);
                        return "Data saved successfully";
                    }
                }

            } catch (error) {
                if (error?.response?.status === 404) {

                    if (new Date() < new Date(date)) {
                        setError(`Select exchange date less than system date!`)
                    }
                    else {
                        setError();
                        if (parseFloat(Number(exchangeRate)) === 0 || isNaN(parseFloat(Number(exchangeRate)))) {
                            setError(`The value for Exchange rate cannot be 0`)
                        } else {
                            const addData = await OAuthService.addData(`${process.env.REACT_APP_FINANCE_API_KEY_URL}api/${oAuthServiceConfig.dailyExchange}/save`, rateData)
                            if (addData) {
                                setSuccessMsg("Data saved successfully")
                                setSnackState(true);
                                return "Data saved successfully";
                            }
                        }
                    }


                }
            }

        }
    }

    const handleDateChange = (value) => {
        setDate(moment(value).format('YYYY-MM-DD'))
        getList(moment(value).format('YYYY-MM-DD'))
    }

    const handlExchangeRate = async (e) => {
        setExchangeRate(e.target.value);
    }

    const editRate = async (id) => {
        const result = await OAuthService.getEditData(url, id);
        if(result.data){
            setDate(result.data.date);
            setError('')
            const place = decimalCount(result.data.euroRate) > 5 ? 5 : decimalCount(result.data.euroRate) ;
            setDecimalPlace(place)
            setExchangeRate(result.data.euroRate.toFixed(place));
    
            const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
    
            const userlist = await OAuthService.getList(userUrl + `?sort=firstName,asc&size=1000`);
            let usercreated = userlist?.data?._embedded?.users.filter((obj) => obj.email === result.data.createdBy);
            let usercreatedBy = usercreated.length > 0 && usercreated[0].firstName + ' ' + usercreated[0].lastName;
            let userupdated = userlist?.data?._embedded?.users.filter((obj) => obj.email === result.data.updatedBy);
            let userupdatedBy = userupdated.length > 0 && userupdated[0].firstName + ' ' + userupdated[0]?.lastName;
            setCreatedAt(result.data.createdAt && moment(result.data.createdAt).format('YYYY-MM-DD'))
            setCreatedBy(usercreatedBy || result.data.createdBy)
            setUpdatedAt(result.data.updatedAt && moment(result.data.updatedAt).format('YYYY-MM-DD'))
            setUpdatedBy(userupdatedBy || result.data.updatedBy)
            setEditData(result.data)
        }
    }

    useEffect(() => {
        if (props.id) {
            editRate(props.id);
        }
    }, [props?.id])

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit
    }));

    function getPreviousDay(date = new Date()) {
        const previous = new Date(date.getTime());
        previous.setDate(date.getDate() - 1);

        return moment(previous).format('YYYY-MM-DD');
    }

    const getList = async (selectedDate) => {
        const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}api/${oAuthServiceConfig.dailyExchange}/base`;
        const yesterdayDate = getPreviousDay(new Date(selectedDate));
        try {
            const list = await OAuthService.getList(url + '?date=' + yesterdayDate);
            if (list?.data) {
                if (decimalPlace) {
                    setExchangeRate(Number(list.data[0].midpoint).toFixed(decimalPlace))
                } else {
                    setExchangeRate(list.data[0].midpoint)
                }
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        if (!params.id) {
            const currentDate = moment(new Date()).format('YYYY-MM-DD');
            setDate(currentDate)
            getList(currentDate)
        }
    }, [])

    useEffect(() => {
        if (date && exchangeRate && !validError) {
            if (editData) {
                if (date !== editData.date || exchangeRate !== editData.euroRate) {
                    setCheckStatus(false)
                } else {
                    setCheckStatus(true)
                }
            } else {
                setCheckStatus(false)
            }
        } else {
            setCheckStatus(true)
        }
    }, [date, exchangeRate, validError])

    useEffect(() => {
        params.checkedStatus(checkStatus)
    }, [checkStatus])

    useEffect(() => {
        params.successMsg(successMsg)
    }, [successMsg]);

    function decimalCount(number) {
        // Convert to String
        const numberAsString = number.toString();
        // String Contains Decimal
        if (numberAsString.includes('.')) {
            return numberAsString.split('.')[1].length;
        }
        // String Does Not Contain Decimal
        return 0;
    }

    const handleDecimalChange = async (e) => {
        setDecimalPlace(e.target.value);
        try {
            const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}api/${oAuthServiceConfig.dailyExchange}/base`;
            const yesterdayDate = getPreviousDay(new Date(date));
            const list = await OAuthService.getList(url + '?date=' + yesterdayDate);
            if(list?.data){
                setExchangeRate(Number(list.data[0].midpoint).toFixed(e.target.value))
            }

        } catch (error) {
            if(exchangeRate){
                setExchangeRate(Number(exchangeRate).toFixed(e.target.value))
            }
        }
    }

    const handleExistEdit = async() => {
        const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.dailyExchangeRate}`
        const getExisted = await OAuthService.getList(url+ `/search/findByDate?date=${date}`);
        if(getExisted?.data){
            setExistId(getExisted?.data?._links?.self?.href.split('/').pop())
        }
        setExistOpen(false)
    }

    useEffect(() => {
        if(existId){
            editRate(existId);
        }
    },[existId])

    return (
        <div>
            {error && <Alert severity="error" className="mb-16">
                <AlertTitle>Error</AlertTitle>
                {error}
            </Alert>}
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    <div className="flex mb-10">
                        <label className="pt-12 grow basis-0 float-left">Date:</label>
                        <Stack className="float-right grow basis-0">
                            <CustomDatePicker
                                // className="float-right"
                                format={'dd-MM-yyyy'}
                                name={'date'}
                                value={date}
                                maxDate={new Date()}
                                handleChange={handleDateChange}
                                disabled={props.viewData && true}
                                renderInput={(params) => <TextField size="small" InputLabelProps={{
                                }} {...params} sx={{
                                    backgroundColor: props.viewData && '#8080800f'
                                }} />}
                            />
                        </Stack>
                    </div>
                    <div className="flex mb-10">
                        <label className="pt-12 grow basis-0 float-left">Resource Money Unit:</label>
                        <Stack className="float-right grow basis-0">

                            <TextField
                                name="resourceMoneyUnit"
                                value={'EUR'}
                                disabled
                                sx={{
                                    backgroundColor: '#8080800f'
                                }}
                                size="small"
                            />
                        </Stack>
                    </div>
                    <div className="flex mb-10">
                        <label className="pt-12 grow basis-0 float-left">Value:</label>
                        <TextField
                            name="value"
                            className="float-right grow basis-0"
                            value={'1'}
                            disabled
                            sx={{
                                backgroundColor: '#8080800f'
                            }}
                            size="small"
                        />
                    </div>
                    <div className="flex mb-10">
                        <label className="pt-12 grow basis-0 float-left">Target Money Unit:</label>
                        <TextField
                            name="targetMoneyUnit"
                            className="float-right grow basis-0"
                            value={'AED'}
                            disabled
                            sx={{
                                backgroundColor: '#8080800f'
                            }}
                            size="small"
                        />
                    </div>
                    <div className="flex mb-10">
                        <label className="pt-12 grow basis-0 float-left">Select decimal place for Exchange Rate & @calculated:</label>
                        <FormControl size="small" className=" grow basis-0">
                            <Select
                                name="decimalPlace"
                                className="float-right"
                                value={decimalPlace}
                                disabled={props.viewData && true}
                                onChange={handleDecimalChange}
                            >
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex mb-10">
                        <label className="pt-12 grow basis-0 float-left">Exchange Rate:</label>
                        <TextField
                            name="exchangeRate"
                            className="float-right grow basis-0"
                            value={exchangeRate}
                            onChange={(e) => { handlExchangeRate(e); setValidError(checkNumber(e.target.value)) }}
                            disabled={props.viewData && true}
                            sx={{
                                backgroundColor: props.viewData && '#8080800f'
                            }}
                            size="small"
                            helperText={validError}
                        />
                    </div>
                </Grid>
                <Grid item xs={6} className="relative">
                    {params.id && <><div className="flex mb-10">
                        <label className="pt-12 grow basis-0 text-center">Created At:</label>
                        <TextField
                            name="createdAt"
                            className="float-right grow basis-0"
                            value={createdAt && moment(createdAt).format('DD-MM-YYYY')}
                            disabled={true}
                            sx={{
                                backgroundColor: '#8080800f'
                            }}
                            size="small"
                        />
                    </div>
                        <div className="flex mb-10">
                            <label className="pt-12 grow basis-0 text-center">Created By:</label>
                            <TextField
                                name="createdBy"
                                className="float-right grow basis-0"
                                value={createdBy}
                                disabled={true}
                                sx={{
                                    backgroundColor: '#8080800f'
                                }}
                                size="small"
                            />
                        </div>
                        <div className="flex mb-10">
                            <label className="pt-12 grow basis-0 text-center">Updated At:</label>
                            <TextField
                                name="updatedAt"
                                className="float-right grow basis-0"
                                value={updatedAt && moment(updatedAt).format('DD-MM-YYYY')}
                                disabled={true}
                                sx={{
                                    backgroundColor: '#8080800f'
                                }}
                                size="small"
                            />
                        </div>
                        <div className="flex mb-10">
                            <label className="pt-12 grow basis-0 text-center">Updated By:</label>
                            <TextField
                                name="updatedBy"
                                className="float-right grow basis-0"
                                value={updatedBy}
                                disabled={true}
                                sx={{
                                    backgroundColor: '#8080800f'
                                }}
                                size="small"
                            />
                        </div></>}
                    <Tooltip title='View Current Conversion Rate'>
                        <Button
                            variant="contained"
                            color="warning"
                            className="absolute bottom-0 right-0"
                            onClick={() => { window.open(`https://bankenverband.de/service/waehrungsrechner/?betrag=1&dezimalstellen=2&von=EUR&in=AED&mit_kurs_vom=${getPreviousDay(new Date(date))}&interbank=0`, '_blank'); }}
                        >
                            <FuseSvgIcon>material-outline:language</FuseSvgIcon>
                        </Button>
                    </Tooltip>
                </Grid>
            </Grid>

            <Dialog   
            fullWidth={true}
                maxWidth={'sm'}
                onClose={() => setExistOpen(false)}
                open={existOpen}
            // {...other}
            >
                <DialogTitle>
                    <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                        <span>Daily Exchange Rate Exist</span>
                        <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                            <Button onClick={() => setExistOpen(false)}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                   Daily Exchange Rate with {date} already exist into system! Do you want to edit it?
                </DialogContent>
                <DialogActions>
                   <Button
                        variant="contained"
                        color="warning"
                        onClick={handleExistEdit}
                    >
                        <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
                    </Button>
                </DialogActions>

            </Dialog>
        </div>
    )
});

export default DailyExchangeRateForm;
